import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
} from '@/components/common/skeleton';

const ITEM_COUNT = 5;

export const OrganizationUsersTabSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <SkeletonBone width={100} height={18} />
    <SkeletonBone width={200} height={14} />
    {Array.from({ length: ITEM_COUNT }).map((_, i) => (
      <SkeletonCard key={i} padding={16}>
        <View style={styles.row}>
          <SkeletonBone width={20} height={20} borderRadius={4} />
          <View style={styles.textColumn}>
            <SkeletonBone width="60%" height={16} />
            <SkeletonBone width="30%" height={12} />
          </View>
        </View>
      </SkeletonCard>
    ))}
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    gap: 12,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  textColumn: {
    flex: 1,
    gap: 6,
  },
});
